import { useContext } from 'react';
import { SessionContext } from './session-context';
import type { SessionState } from './session-context';

/**
 * Hook to access session state. Must be used within a SessionProvider.
 */
export function useSession(): SessionState {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return ctx;
}

/**
 * Session state when there IS a provider, undefined when there is not.
 *
 * useSession() throws without a provider, which is right for anything whose
 * correctness depends on knowing who is signed in. It is wrong for a cosmetic
 * read — the share message wants the business name and can say "your service
 * provider" if it cannot get one. Using the throwing hook for that coupled two
 * detail pages to a provider their tests deliberately do not mount.
 */
export function useOptionalSession(): SessionState | undefined {
  return useContext(SessionContext);
}
